import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.main.overview');
import { OnInit, ChangeDetectorRef as CDR, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let wiz: any;

@Component({
    selector: 'wiz-component-main-overview',
template: templateSource || '',
    styles: [``],
})
export class ComponentMainOverviewComponent implements OnInit {
    /** 진단 유형별 프로젝트 그룹 */
    @Input() grouped: any = { regular: [], fine: [], diagnosis: [], other: [] };
    
    /** 통계 */
    @Input() stats: any = { total: 0, regular: 0, fine: 0, diagnosis: 0 };
    
    /** 선택된 프로젝트 목록 (체크 상태 확인용) */
    @Input() selectedProjects: any[] = [];
    
    /** 프로젝트 선택 완료 이벤트 (성공 시 변경된 목록 전달) */
    @Output() onSelected = new EventEmitter<any[]>();
    
    /** 펼쳐진 아코디언 상태 */
    public expanded: any = {
        regular: false,
        fine: false,
        diagnosis: false,
        other: false
    };

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        // 페이지에서 init/렌더를 담당
    }

    /** 아코디언 토글 */
    public toggleAccordion(type: string) {
        this.expanded[type] = !this.expanded[type];
        this.ref.detectChanges();
    }
    
    /** 프로젝트 선택 토글 - 직접 API 호출 */
    public async toggle(project: any) {
        const idx = this.selectedProjects.findIndex(p => p.id === project.id);
        let newList: any[];
        
        if (idx >= 0) {
            // 선택 해제
            const { code } = await wiz.call("unselect", { project_id: project.id });
            if (code === 200) {
                newList = this.selectedProjects.filter(p => p.id !== project.id);
            } else {
                return;
            }
        } else {
            // 선택 추가
            const { code } = await wiz.call("select", { project_id: project.id });
            if (code === 200) {
                newList = [...this.selectedProjects, project];
            } else {
                return;
            }
        }
        
        // 부모에게 변경된 목록 전달
        this.onSelected.emit(newList);
    }
    
    /** 프로젝트가 선택되었는지 확인 */
    public isSelected(project: any): boolean {
        if (!Array.isArray(this.selectedProjects)) {
            return false;
        }
        return this.selectedProjects.some(p => p.id === project.id);
    }
}

export default ComponentMainOverviewComponent;